import React from 'react';
import { Menu } from 'react-feather';
import Icon, { IconColors, IconSizes } from '../../../icon/icon';

const CMEmptyState = () => (
  <Icon icon={Menu} size={IconSizes.LARGE} color={IconColors.GREY} />
);

export default CMEmptyState;
